import {LineIntersType} from "../../../types";
import * as THREE from "three";

interface PropsLine extends LineIntersType {
  symbol: string;
}
export class LineLinkPoint extends THREE.Line {
  start: THREE.Vector3;
  end: THREE.Vector3;
  material = new THREE.LineBasicMaterial({
    color: '#3c3c3c',
    linewidth: 1,
    // scale: 0.1,
    // dashSize: 0.003,
    // gapSize: 0.003,
  });
  symbol: string;
  constructor({ start, end, symbol }: PropsLine) {
    super();
    this.type = 'line_linking';
    this.name = 'line_linking';
    this.start = start;
    this.end = end;
    this.symbol = symbol;

    this.buildGeometry();
  }

  buildGeometry() {
    if (this.geometry) {
      this.geometry.dispose();
    }
    this.geometry = new THREE.Geometry().setFromPoints([this.start, this.end]);
    this.computeLineDistances();
  }
  updateLineGeometry(newPos: THREE.Vector3, point: keyof LineIntersType) {
    this[point].copy(newPos);
    const index = point === 'start' ? 0 : 1;
    const geomLine = this.geometry as THREE.Geometry;
    geomLine.vertices[index].copy(newPos);
    geomLine.verticesNeedUpdate = true;
  }
  removeMesh() {
    if (this.geometry) {
      this.geometry.dispose();
    }
    if (this.material) {
      (this.material as THREE.LineDashedMaterial).dispose();
    }
    this.parent?.remove(this);
  }
}
